import * as PropType from '../common/propType';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import React from 'react';
import IScroll from "../../com/iscroll"
window["IScroll"] = IScroll;

import './index.less';

export interface IScrollerFetchable {
    canFetch: boolean;
    fetch: (page) => void;
    list?: any[];
    page: number;
    isLoadOk: any;
}
declare var window: any;
window.isLoadOk = "ok";
export interface ScrollerPropType extends PropType.StylePropType {
    renderHeader?: () => JSX.Element | JSX.Element[]; // 页面头部
    renderFooter?: () => JSX.Element | JSX.Element[]; // 页面底部
    renderItem?: (data: any, idx: number) => JSX.Element | JSX.Element[]; // 直接遍历
    renderContent?: () => JSX.Element | JSX.Element[]; // 自由遍历
    onScrollStart?: (x, y) => void; // 滑动开始
    onScrollEnd?: (x, y, pagey) => void; // 滑动结束
    onScroll?: (x, y, pagey) => void; // 滑动中
    scrollTo?: (x, y) => void;
    freeHeight?: number; // 底部高度
    prefixCls?: string; // 页面初始样式
    autoFetch?: boolean; // 是否加载
    fetchable?: IScrollerFetchable; // 数据
    emptyView?: () => JSX.Element; // 空缺页面
    listStyle?: any;
    listClassName?: string;
    myY?: number;
    myup?: any;
    latext?: any;
}

@observer
class Scroller extends React.Component<ScrollerPropType> {
    private scroller: any;
    private label: HTMLElement;
    private wrapper: HTMLElement;
    isPulled: any = false; // 拉动标记
    latext: any = "释放刷新";

    static defaultProps = {
        prefixCls: 'scroller',
        autoFetch: false,
    };

    private refMap = {
        wrapper: (obj) => this.wrapper = obj,
        label: (obj) => this.label = obj
    };

    componentDidMount() {
        this.scroller = new window['IScroll'](this.wrapper, {
            ansp: "#banner",
            mouseWheel: true,
            click: true,
            tap: true,
            hScroll: false,
            vScroll: true,
            probeType: 3,
            disablePointer: true,
            disableTouch: false,
            disableMouse: false,
            isrule: false,
            scrollX: true,
            scrollY: true,
            topOffset: this.props.myup && 40,
        });
        this.scroller.on('scroll', this.onScroll.bind(this));
        this.scroller.on('scrollStart', this.onScrollStart.bind(this));
        this.scroller.on('scrollEnd', this.onScrollEnd.bind(this))
        this.scroller.refresh();
        this.props.myY && this.scroller.scrollTo(0, this.props.myY);
        let myIs: any = this.wrapper;
        myIs.addEventListener('touchmove', function (e) {
            e.preventDefault();
        }, false);
        let that = this
        this.props.myup && document.addEventListener("touchend", function () {
            that.latext = "加载中";
        })
    }

    componentDidUpdate() {
        this.scroller.refresh();
    }

    componentWillUnmount() {}

    refresh() {
        this.scroller.refresh();
    }

    scrollTo(x = 0, y = 0) {
        this.scroller.scrollTo(x, y);
    }

    scrollToElement(id) {
        if (id) {
            this.scroller.scrollToElement(id, 100);
        }
    }

    onScroll(x, y, pagey) {
        if (this.props.onScroll) {
            this.props.onScroll(x, y, pagey)
        }
    }

    /**
     * 下拉中
     * @param that // this
     * @param y // 滚动条
     */
    onScrollup(that, y) {}

    time: any = null;

    // 下拉完成
    onScrollEndup(that, y) {}

    onScrollEnd() {}

    onScrollStart() {
        console.log("this.scroller.x, this.scroller.y=============>", this.scroller.x, this.scroller.y)
        if (this.props.onScrollStart) {
            this.props.onScrollStart(this.scroller.x, this.scroller.y);
        }
    }

    refreshPullUp(mode: string) {}

    upview() {
        return this.props.myup && <div id="PullDown" className="scroller-pullDown" style={{ paddingBottom: this.props.myup, visibility: "hidden", marginTop: "-" + (parseInt(this.props.myup)) + "px" }}>
            <span id="pullDown-msg" className="pullDownLabel">下拉刷新</span>
        </div>
    }

    render() {
        const { renderHeader, renderFooter, renderContent, renderItem, prefixCls, emptyView, fetchable, freeHeight, listStyle, listClassName } = this.props;
        let list: any[] = [];
        if (fetchable && fetchable.list) {
            list = fetchable.list;
            this.refresh.bind(this)
        }
        let style = PropType.getStyle(this.props);
        var h = (document.documentElement.clientHeight || document.getElementsByTagName("html")[0].offsetHeight) - (freeHeight || 0);
        if (!style.height) {
            style.height = h;
        }
        let header = renderHeader && <div className={`${prefixCls}-header`}>
            {renderHeader()}
        </div>;
        let footer = renderFooter && <div className={`${prefixCls}-footer`}>
            {renderFooter()}
        </div>;
        let contentStyle: any = { minHeight: h };
        let el;
        if (renderContent) {
            el = (
                <div ref={this.refMap.wrapper} style={style} className={`${prefixCls}`}>
                    <div className={`${prefixCls}-content`} style={contentStyle}>
                        {this.upview()}
                        {header && header}
                        {list && renderItem && list.map((item, idx) => {
                            return renderItem(item, idx)
                        })}
                        {renderContent()}
                    </div>
                    {footer && footer}
                </div>
            )
        } else {
            if (list && list.length == 0 && emptyView) {
                el = <div ref={this.refMap.wrapper} style={style} className={`${prefixCls}`}>
                    <div className={`${prefixCls}-content`} style={contentStyle}>
                        {this.upview()}
                        {header}
                        <div className={`${prefixCls}-empty`}>
                            {emptyView()}
                        </div>
                    </div>
                    {footer}
                </div>
            } else {
                let listClass = classnames(prefixCls + '-list', listClassName);
                el = <div ref={this.refMap.wrapper} style={style} className={`${prefixCls}`}>
                    <div className={`${prefixCls}-content`} style={contentStyle}>
                        {this.upview()}
                        {header}
                        <div style={listStyle} className={listClass}>
                            {list && renderItem && list.map((item, idx) => {
                                return renderItem(item, idx)
                            })}
                        </div>
                    </div>
                    {footer}
                </div>
            }
        }
        return el
    }
    canFetch() {
        let { fetchable } = this.props;
        if (fetchable) {
            return fetchable.canFetch;
        }
        return false;
    }
}
declare var window: any
export default Scroller;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/scroller/index.tsx